export const positionList = [
  {
    text: 'Руководитель',
    value: 'supervisor',
  },
  {
    text: 'Работник',
    value: 'employee',
  },
];

export const statusList = [
  {
    value: 'work',
    text: 'Работает',
  },
  {
    value: 'fired',
    text: 'Уволен',
  },
];

export const workWeekList = [
  {
    text: 'Пятидневка',
    value: 5,
  },
  {
    text: 'Шестидневка',
    value: 6,
  },
];

export const citizenshipList = [
  {
    text: 'Резидент РК',
    value: 'resident',
  },
  {
    text: 'Нерезидент из ЕАЭС',
    value: 'nonResidentFromEAEU',
  },
  {
    text: 'Нерезидент с ВНЖ',
    value: 'nonResidentWithResidencePermit',
  },
  {
    text: 'Нерезидент без ВНЖ',
    value: 'nonResidentWithoutResidencePermit',
  },
  {
    text: 'Лицо без гражданства',
    value: 'statelessPerson',
  },
];

export const calculationTypeList = [
  { text: 'Зарплата c налогами (оклад)', value: 'dailySalary' },
  { text: 'Зарплата на руки', value: 'dailySalaryReverse' },
  { text: 'Договор ГПХ на руки', value: 'gpc' },
  { text: 'Договор ГПХ с налогами', value: 'gpcReverse' },
];

export const disabilityList = [
  { text: 'Не инвалид', value: 'notDisabled' },
  { text: 'Инвалид I, II, III группы', value: 'disabledPerson' },
  {
    text: 'Инвалид I, II группы бессрочно',
    value: 'disabledPersonIndefinitely',
  },
  {
    text: 'Родитель инвалида с детства: I, II, III – группы',
    value: 'disabledParentChildhood',
  },
];

export const positionMap = {
  supervisor: 'Руководитель',
  employee: 'Работник',
};

export const statusMap = {
  work: 'Работает',
  fired: 'Уволен',
};

export const workWeekMap = {
  5: 'Пятидневка',
  6: 'Шестидневка',
};

export const citizenshipMap = {
  resident: 'Резидент РК',
  nonResidentFromEAEU: 'Нерезидент из ЕАЭС',
  nonResidentWithResidencePermit: 'Нерезидент с ВНЖ',
  nonResidentWithoutResidencePermit: 'Нерезидент без ВНЖ',
  statelessPerson: 'Лицо без гражданства',
};

export const calculationTypeMap = {
  dailySalaryReverse: 'Зарплата на руки',
  dailySalary: 'Зарплата c налогами (оклад)',
  gpc: 'Договор ГПХ на руки',
  gpcReverse: 'Договор ГПХ с налогами',
};

export const disabilityMap = {
  notDisabled: 'Не инвалид',
  disabledPerson: 'Инвалид I, II, III группы',
  disabledPersonIndefinitely: 'Инвалид I, II группы бессрочно',
  disabledParentChildhood: 'Родитель инвалида с детства: I, II, III – группы',
};
